import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { Drawer } from "antd5";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";

type Props = {
  entityType: "bid" | "lead";
  isOpen: boolean;
  onClose: () => void;
  width?: number;
  children: ReactNode;
};

export function CreateEntityDrawer({ entityType, isOpen, onClose, width = 486, children }: Props) {
  return (
    <Drawer
      placement="right"
      open={isOpen}
      width={width}
      onClose={(event) => {
        event.stopPropagation();
        onClose();
      }}
      styles={{ header: { display: "none" }, body: { padding: "24px" } }}
      onClick={(event) => {
        event.stopPropagation();
      }}
      aria-label={`Create new ${entityType}`}
    >
      <Content>
        <Flex justifyContent="space-between" alignItems="center">
          <Text h2>Create new {entityType}</Text>
          <Button icon="xClose" iconProps={{ size: 16 }} buttonType="tertiary" onClick={onClose} />
        </Flex>
        {children}
      </Content>
    </Drawer>
  );
}

const Content = styled(Flex)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flexGrow: 1,
  gap: 24,
});
